import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
const DiscountApprovalForm = (props) => {
  const frmRef = useRef({});
  const [employeeData, setEmployeeData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState("");
  const [discountData, setDiscountData] = useState("");
  const [isIndividual, setIsIndividual] = useState(false);

  const [data, setData] = useState();
  const { sendRequest: getDiscount } = useHttp();

  useEffect(() => {
    getDiscount(
      {
        url: `/api/discountApproval/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log(data);
        setDiscountData(data);
      }
    );
  }, [getDiscount]);

  useEffect(() => {}, [discountData]);

  const { sendRequest: getEmp } = useHttp();

  const loadData = () => {
    getEmp(
      {
        url: `/api/employeeListForDiscount/?useCase=Procurement&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("emp11", data);
        var i = 0;

        setData(data.employeeList);

        var tempempdata = data.employeeList;

        if (props.update) {
          tempempdata = data.employeeList.filter((employee) =>
            employee.employeeName
              .toLowerCase()
              .includes(props.update.employeeName.toLowerCase())
          );

          setFilteredEmployees(props.update.employeeName);
        }
        var userTarget = data.useDiscount;

        //console.log("userTarget", userTarget);
        //console.log("tempempdata", tempempdata);
        // var tempempdata = data.employeeList;
        var newempList = [];

        do {
          var emp = tempempdata[i];
          var tlist = userTarget.filter(
            (item) => item.procurementOfficerId == emp.empId
          );
          var tdata = tlist && tlist[0];

          newempList = newempList.concat({
            userId: tempempdata[i].userId,

            useCase: tempempdata[i].useCase,
            empId: tempempdata[i].empId,
            employeeName: tempempdata[i].employeeName,
            fromDate: tdata && tdata.fromDate,
            toDate: tdata && tdata.toDate,
            discount: tdata && tdata.discountPercentage,
          });
          i++;
        } while (tempempdata.length > i);

        //console.log("newempList", newempList);

        setEmployeeData(newempList);
        setFilteredEmployees(newempList);
      }
    );
  };

  useEffect(() => {
    loadData();
  }, [getEmp]);

  const handleApplyAllClick = (event) => {
    event.preventDefault();
    const discountInputValues = frmRef.current["discount_approval"].value;
    const fromDateValue = frmRef.current["from_date"].value;
    const toDateValue = frmRef.current["to_date"].value;
    const discountInputs = document.querySelectorAll(".discount-input");

    discountInputs.forEach((discountInput, i) => {
      discountInput.value = discountInputValues;

      filteredEmployees[i].discount = discountInputValues;
      filteredEmployees[i].fromDate = fromDateValue;
      filteredEmployees[i].toDate = toDateValue;

      //console.log(filteredEmployees);
      setFilteredEmployees(filteredEmployees);
    });

    var i = 0;
  };

  const handleSearchChange = (event) => {
    //console.log(event.target.value);
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    const filteredEmployee = employeeData.filter((employee) =>
      employee.employeeName.toLowerCase().includes(searchQuery.toLowerCase())
    );

    //console.log(filteredEmployee);

    setFilteredEmployees(filteredEmployee);
  }, [searchQuery]);

  const { sendRequest: postDiscountApproval } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault(false);

    const promises = filteredEmployees.map((emp) => {
      const data = {
        discountApprovalDate: moment(
          new Date().toISOString().slice(0, 10)
        ).format("DD/MM/YYYY"),
        fromDate: moment(frmRef.current.from_date.value).format("DD/MM/YYYY"),
        toDate: moment(frmRef.current.to_date.value).format("DD/MM/YYYY"),
        procurementOfficerId: emp.empId,
        discountPercentage: emp.discount,
        createdDate: moment(new Date().toISOString().slice(0, 10)).format(
          "DD/MM/YYYY"
        ),
        status: 1,
        orgId: parseInt(localStorage.getItem("orgId")),
        createdBy: parseInt(localStorage.getItem("id")),
        warehouseId: parseInt(localStorage.getItem("warehouseId")),
      };

      if (props.update.discountApprovalId) {
        data["discountApprovalId"] = props.update.discountApprovalId;
      }

      //console.log(data);

      const existingRecord =
        discountData &&
        discountData.find(
          (target) => target.procurementOfficerId === emp.empId
        );
      if (existingRecord) {
        //console.log(existingRecord);

        return Promise.all([
          postDiscountApproval({
            url: `/api/discountApproval/`,
            method: "PUT",
            body: { ...existingRecord, status: 0 },
          }),
          postDiscountApproval({
            url: "/api/discountApproval/",
            method: "POST",
            body: data,
          }),
        ]);
      } else {
        return postDiscountApproval({
          url: "/api/discountApproval/",
          method: props.update.discountApprovalId ? "PUT" : "POST",
          body: data,
        });
      }
    });

    Promise.all(promises)
      .then(() => {
        toast.success(`Discount ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
      })
      .catch((error) => {
        toast.error(`Error: ${error.message}`);
      });
  };

  useEffect(() => {
    //console.log(props.update);

    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp11", data.output);
        const employee = data.output.find(
          (emp) => emp.empId === props.update.procurementOfficerId
        );

        if (employee) {
          //console.log("Employee name:", employee.employeeName);
          frmRef.current.emp_name.value = employee.employeeName;
          setSearchQuery(employee.employeeName);
        }
      }
    );

    if (props.update) {
      setIsIndividual(true);
      frmRef.current.discount_approval.value = props.update.discountPercentage;
      frmRef.current.from_date.value = moment(
        props.update.fromDate,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
      frmRef.current.to_date.value = moment(
        props.update.toDate,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Discount Approval Details </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Team</label> &nbsp;
                        <input
                          type={"checkbox"}
                          id={"team"}
                          ref={(el) => (frmRef.current["team"] = el)}
                          className="checkbox"
                          onChange={(event) => {
                            //frmRef.current.individual.checked=false;
                            setIsIndividual(false);
                          }}
                          disabled={props.update}
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Individual</label> &nbsp;
                        <input
                          type={"checkbox"}
                          id={"individual"}
                          ref={(el) => (frmRef.current["individual"] = el)}
                          className="checkbox"
                          checked={isIndividual}
                          onChange={(event) => {
                            frmRef.current.team.checked = false;
                            setIsIndividual(event.target.checked);
                            loadData();
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      {isIndividual && (
                        <div className="form-group">
                          <label htmlFor={"from_date"} className="inputs">
                            {"Search Procurement Officer"}
                          </label>
                          {/* <input
                        type="text"
                        placeholder="Search"
                        className="search inputs dropdowns"
                        value={searchQuery}
                        onChange={handleSearchChange}
                      /> */}

                          <select
                            id="emp_name"
                            className="form-control"
                            ref={(el) => (frmRef.current["emp_name"] = el)}
                            onChange={handleSearchChange}
                            disabled={props.update}
                          >
                            <option value="">Select</option>
                            {employeeData &&
                              employeeData.map((x) => (
                                <option
                                  key={x.empId}
                                  value={x.employeeName}
                                  selected={
                                    props.update &&
                                    x.empId === props.update.empId
                                  }
                                >
                                  {x.employeeName}
                                </option>
                              ))}
                          </select>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>From Date</label>

                        <input
                          type={"date"}
                          id={"from_date"}
                          required
                          ref={(el) => (frmRef.current["from_date"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label>To Date</label>
                        <input
                          type={"date"}
                          id={"to_date"}
                          required
                          ref={(el) => (frmRef.current["to_date"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Set Discount</label>

                        <input
                          type="text"
                          className="form-control"
                          ref={(el) =>
                            (frmRef.current["discount_approval"] = el)
                          }
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Apply All</label> <br />
                        <button
                          className="btn  btn-primary mx-2 my-2"
                          onClick={handleApplyAllClick}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr className="tableheaderrowview">
                          <th>Procurement Officer Name</th>
                          <th>Discount </th>
                          <th>Previous From Date</th>

                          <th>Previous To Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredEmployees &&
                          filteredEmployees.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.employeeName}</td>
                                <td>
                                  <input
                                    type={"text"}
                                    required
                                    className="discount-input"
                                    style={{
                                      width: "100px",
                                      textAlign: "center",
                                    }}
                                    ref={(el) =>
                                      (frmRef.current["set_discount_approval"] =
                                        el)
                                    }
                                    value={itm.discount}
                                    autoComplete="off"
                                    disabled
                                  />
                                </td>
                                <td>{itm.fromDate}</td>

                                <td>{itm.toDate}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button className="btn  btn-primary mx-2 my-2" type="submit">
                        Add
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default DiscountApprovalForm;
